/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Refresh_Desc7Inputs */

const en_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices, availability and stats refresh on schedule so pages stay accurate.`)
};

const ar_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار والتوافر والإحصاءات تُحدَّث بجدول لتبقى الصفحات دقيقة.`)
};

const bn_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দাম, প্রাপ্যতা আর পরিসংখ্যান সময়সূচিতে তাজা হয় যাতে পৃষ্ঠা নির্ভুল থাকে।`)
};

const de_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise, Verfügbarkeit und Statistiken werden planmäßig aktualisiert, damit Seiten korrekt bleiben.`)
};

const es_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios, disponibilidad y estadísticas se actualizan según calendario para que las páginas sigan precisas.`)
};

const fr_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix, disponibilité et statistiques actualisés selon calendrier pour garder des pages exactes.`)
};

const pt_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços, disponibilidade e estatísticas atualizados com calendário para páginas sempre precisas.`)
};

const zh_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格、库存和数据定时刷新，页面永远准确。`)
};

const tr_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat, stok ve istatistikler zamanlı tazelenir, sayfalar hep doğru kalır.`)
};

const ru_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены, наличие и статистика обновляются по расписанию, чтобы страницы оставались точными.`)
};

const pl_svc_programmatic_seo_refresh_desc7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny, dostępność i statystyki odświeżane według planu, by strony zostawały dokładne.`)
};

/**
* | output |
* | --- |
* | "Prices, availability and stats refresh on schedule so pages stay accurate." |
*
* @param {Svc_Programmatic_Seo_Refresh_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_refresh_desc7 = /** @type {((inputs?: Svc_Programmatic_Seo_Refresh_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Refresh_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "de") return de_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "es") return es_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_refresh_desc7(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_refresh_desc7(inputs)
	return en_svc_programmatic_seo_refresh_desc7(inputs)
});
export { svc_programmatic_seo_refresh_desc7 as "svc_programmatic-seo_REFRESH_desc" }